module.exports = __webpack_public_path__ + "4eab01ecff6892ecd6580a73b3a46edd.svg";